import { isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';
import { of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { UserService } from '@modules/shared/services/user.service';

@Injectable()
export class AuthGuard implements CanActivate {
  private userService = inject(UserService);
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  canActivate() {
    if (!this.isBrowser) {
      return of(true);
    }
    return this.userService.isLoggedIn().pipe(
      take(1),
      map((loggedIn) => {
        if (loggedIn) {
          return true;
        } else {
          this.userService.login();
          return false;
        }
      })
    );
  }
}
